<template>
  <div class="create-leaveType">
    <div class="btn-wrapper mb-10 mr-20 move-right">
      <router-link to="/admin/hrm/leave/settings/leave-type" class="btn-back">
        <span>Back</span>
      </router-link>
    </div>
    <el-form
      :model="leaveTypeForm"
      :rules="rules"
      ref="leaveTypeForm"
      class="white-bg form"
      label-position="left"
      label-width="200px"
    >
      <h3 class="text-gray bold mt-0 mb-40">Create New Leave Type</h3>
      <div class="mt-20"></div>
      <el-form-item label="Leave Type name" prop="leave_name" class="mt-20">
        <el-input
          v-model="leaveTypeForm.leave_name"
          placeholder="Type Leave Name e.g Maternity, Annual"
          type="text"
        ></el-input>
      </el-form-item>
      <el-form-item label="Include Weekends?" prop="weekend">
        <el-checkbox-group v-model="leaveTypeForm.weekend">
          <el-checkbox label="Saturday"></el-checkbox>
          <el-checkbox label="Sunday"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        label="Exclude Public Holidays?"
        prop="exclude_public_holidays"
      >
        <el-switch v-model="leaveTypeForm.exclude_public_holidays"></el-switch>
      </el-form-item>
      <el-form-item label="Duration" prop="applicable_days">
        <el-input
          v-model="leaveTypeForm.applicable_days"
          placeholder=""
          type=""
          @keypress.native="onlyNumbers"
          ><template slot="append">{{ "days" }}</template>
        </el-input>
      </el-form-item>
      <el-form-item label="Gender Based?">
        <el-tooltip
          :content="`Gender Based : ${isGenderBased === true ? 'Yes' : 'No'}`"
          placement="top"
        >
          <el-switch
            v-model="isGenderBased"
            active-color="#066aff"
            @change="resetGenderRadioButton()"
          >
          </el-switch>
        </el-tooltip>
      </el-form-item>
      <div v-if="isGenderBased === true">
        <el-form-item
          label="Gender"
          prop="gender"
          class="center-middle genderField"
        >
          <el-radio-group v-model="leaveTypeForm.gender" name="gender">
            <el-radio
              v-for="item in genderList"
              :key="item.id"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item label="Description" prop="note">
        <el-input
          type="textarea"
          v-model="leaveTypeForm.note"
          :rows="3"
        ></el-input>
      </el-form-item>
      <el-form-item label="Paid Leave Type" prop="is_paid">
        <el-checkbox v-model="leaveTypeForm.is_paid"
          >This is a paid leave type</el-checkbox
        >
      </el-form-item>
      <h3>Apply to</h3>
      <el-form-item label="All Branches?" prop="is_generic">
        <el-switch v-model="leaveTypeForm.is_generic" class="mt-10"></el-switch>
      </el-form-item>
      <div v-if="!leaveTypeForm.is_generic">
        <el-form-item label="Select Branch" prop="branch_id" class="mt-20">
          <el-select
            style="width: 542px"
            v-model="leaveTypeForm.branch_id"
            placeholder="Select"
            name="branch_id"
          >
            <el-option
              v-for="branch in branches"
              :key="branch.id"
              :label="branch.station_name"
              :value="branch.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <h3>Assign to</h3>
      <el-form-item label class label-width="0px">
        <el-radio-group v-model="leaveTypeForm.category_type">
          <el-radio label="all_users">All Users</el-radio>
          <el-radio label="department">Department</el-radio>
          <el-radio label="station_grade">Grade</el-radio>
          <el-radio label="employees">Employees</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="mt-20" v-show="leaveTypeForm.category_type === 'department'">
        <el-form-item
          label="Select Department"
          prop="departments"
          class="mt-20"
        >
          <el-select
            style="width: 542px"
            v-model="leaveTypeForm.departments"
            multiple
            placeholder="Select"
          >
            <el-option
              v-for="department in departments"
              :key="department.id"
              :label="department.department_name"
              :value="department.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="mt-20" v-show="leaveTypeForm.category_type === 'employees'">
        <el-form-item label="Select Employee" class="mt-20" prop="employees">
          <el-select
            style="width: 542px"
            v-model="leaveTypeForm.employees"
            placeholder="Select"
            filterable
            remote
            :remote-method="searchEmployees"
            multiple
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div
        class="mt-20"
        v-show="leaveTypeForm.category_type === 'station_grade'"
      >
        <el-form-item label="Select Grade" class="mt-20" prop="grades">
          <el-select
            style="width: 542px"
            v-model="leaveTypeForm.grades"
            placeholder="Select"
            multiple
          >
            <el-option
              v-for="grade in employeeGrades"
              :key="grade.id"
              :label="grade.grade_name"
              :value="grade.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="btn-wrapper">
        <el-button
          @click.prevent="create()"
          :loading="loading"
          class="btn btn-blue no-border btn-full-radius inline-flex mt-20 flex-v-end mr-15"
        >
          Create
        </el-button>
        <button
          class="btn btn-light-gray no-border btn-full-radius inline-flex flex-v-end mr-15"
          @click.prevent="$router.go(-1)"
        >
          Cancel
        </button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import debounce from "lodash.debounce";
import { onlyNumbers } from "@/helpers/validation.js";

const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  data() {
    const customValidation = (rule, value, callback) => {
      const categoryTypeMap = {
        employees: this.leaveTypeForm.employees,
        department: this.leaveTypeForm.departments
          ? [this.leaveTypeForm.departments]
          : [],
        station_grade: this.leaveTypeForm.grades,
      };

      if (
        this.leaveTypeForm.category_type !== "all_users" &&
        !categoryTypeMap[this.leaveTypeForm.category_type].length > 0
      ) {
        return callback(new Error(`Please select ${rule.field}`));
      } else {
        return callback();
      }
    };
    return {
      leaveTypeForm: {
        period_type: "Day",
        leave_name: "",
        weekend: [],
        exclude_public_holidays: true,
        applicable_days: "",
        branch_id: null,
        category_type: "all_users",
        employees: [],
        departments: [],
        grades: [],
        note: "",
        gender: null,
        is_generic: true,
        is_paid: true,
      },
      isGenderBased: false,
      genderList: [
        { id: 1, label: "Male", value: "male" },
        { id: 2, label: "Female", value: "female" },
      ],
      employees: [],
      loading: false,
      rules: {
        leave_name: [
          {
            required: true,
            message: "Please input leave type name",
            trigger: "blur",
          },
        ],
        applicable_days: [
          {
            required: true,
            message: "Please input leave duration",
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: "Please select gender",
            trigger: "change",
          },
        ],
        category_type: [
          {
            required: true,
            message: "",
          },
        ],
        departments: [
          {
            required: true,
            message: "Please select department ",
            validator: customValidation,
          },
        ],
        grades: [
          {
            required: true,
            message: "Please select grade ",
            validator: customValidation,
          },
        ],
        employees: [
          {
            required: true,
            message: "Please select employee ",
            validator: customValidation,
          },
        ],
        branch_id: [
          { required: true, message: "Please select branch", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getBranches();
    this.getEmployeeGrades();
    this.getDepartments();
  },
  computed: {
    ...mapState(["branches", "departments", "employeeGrades"]),
  },
  methods: {
    onlyNumbers,
    ...mapActions([
      "getBranches",
      "createleaveType",
      "getEmployeeGrades",
      "getDepartments",
      "getLeaveTypeById",
    ]),

    create() {
      this.$refs[`leaveTypeForm`].validate(valid => {
        if (valid) {
          this.loading = true;
          const inputData = {
            leave_name: this.leaveTypeForm.leave_name,
            weekend: this.leaveTypeForm.weekend,
            exclude_public_holidays: this.leaveTypeForm.exclude_public_holidays,
            applicable_days: this.leaveTypeForm.applicable_days,
            period_type: this.leaveTypeForm.period_type,
            ...(this.leaveTypeForm.category_type === "all_users" && {
              category_type: this.leaveTypeForm.category_type,
            }),
            ...(this.leaveTypeForm.category_type === "department" && {
              category_type: this.leaveTypeForm.category_type,
              departments: this.leaveTypeForm.departments,
            }),
            ...(this.leaveTypeForm.category_type === "station_grade" && {
              category_type: this.leaveTypeForm.category_type,
              grades: this.leaveTypeForm.grades,
            }),
            ...(this.leaveTypeForm.category_type === "employees" && {
              category_type: this.leaveTypeForm.category_type,
              employees: this.leaveTypeForm.employees,
            }),
            branch_id: this.leaveTypeForm.branch_id,
            is_generic: this.leaveTypeForm.is_generic === true ? 1 : 0,
            note: this.leaveTypeForm.note,
            is_paid: this.leaveTypeForm.is_paid,
          };

          const leaveName = this.leaveTypeForm.leave_name.toLowerCase();

          if (leaveName.includes("maternity")) {
            this.leaveTypeForm.gender = "female";
            const updatedinputData = {
              ...inputData,
              gender: this.leaveTypeForm.gender,
            };
            this.addLeaveType(updatedinputData);
          } else if (leaveName.includes("paternity")) {
            this.leaveTypeForm.gender = "male";
            const updatedinputData = {
              ...inputData,
              gender: this.leaveTypeForm.gender,
            };
            this.addLeaveType(updatedinputData);
          } else if (this.isGenderBased === true) {
            const updatedinputData = {
              ...inputData,
              gender: this.leaveTypeForm.gender,
            };
            this.addLeaveType(updatedinputData);
          } else {
            this.addLeaveType(inputData);
          }
        }
      });
    },
    addLeaveType(data) {
      this.$store
        .dispatch("admin/hrm/leave/createLeaveType", data)
        .then(() => {
          this.loading = false;
          this.$router.push({
            path: "/admin/hrm/leave/settings/leave-type",
          });
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
    resetGenderRadioButton() {
      if (this.isGenderBased === false) {
        this.leaveTypeForm.gender = null;
      }
    },
    searchEmployees: debounce(function(searchQuery) {
      this.$store
        .dispatch("searchEmployees", searchQuery)
        .then(response => {
          this.employees = response;
        })
        .catch(() => {});
    }, 500),
  },
};
</script>
